// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__c7C9w","active":"Nav_active__d8Wxx"};